import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as actions from './actions'
import * as asyncActions from './actionsAsync'
import * as layoutActions from 'Global/Stores/layout'
import * as previewModalActions from 'Global/Stores/previewModal'
import * as rugsAsyncActions from 'Global/Stores/rugs'
import * as selectors from './selectors'

const module = 'search'

const layoutToggle = layoutActions.makeLayoutToggle(module)
const limitToggle = layoutActions.makeLimitToggle(module)
const pageSet = layoutActions.makePageSet(module)
const previewModalToggle = previewModalActions.makePreviewModalToggle(module)
const sortBySet = layoutActions.makeSortBySet(module)
const sortOrderToggle = layoutActions.makeSortOrderToggle(module)

const SearchModuleEnhancer = WrappedComponent => {
  class SearchModuleEnhancer extends Component {
    static propTypes = {
      allRugs: PropTypes.array.isRequired,
      dones: PropTypes.object.isRequired,
      errors: PropTypes.object.isRequired,
      exportToExcel: PropTypes.func.isRequired,
      extendedFilters: PropTypes.object.isRequired,
      filteredRugs: PropTypes.array.isRequired,
      filters: PropTypes.object.isRequired,
      getRugs: PropTypes.func.isRequired,
      layout: PropTypes.string.isRequired,
      limit: PropTypes.number.isRequired,
      pagination: PropTypes.object.isRequired,
      pendings: PropTypes.object.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      resetSaveSearch: PropTypes.func.isRequired,
      router: PropTypes.object.isRequired,
      rugsDone: PropTypes.bool.isRequired,
      rugsError: PropTypes.bool.isRequired,
      rugsPending: PropTypes.bool.isRequired,
      rugsRaw: PropTypes.object.isRequired,
      saveSearch: PropTypes.func.isRequired,
      setPage: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      searchForm: PropTypes.bool.isRequired,
      sortBy: PropTypes.string.isRequired,
      sortOrder: PropTypes.string.isRequired,
      toggleLayout: PropTypes.func.isRequired,
      toggleLimit: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      toggleSearchForm: PropTypes.func.isRequired,
      toggleSortOrder: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { getRugs, rugsDone } = this.props

      if (!rugsDone) {
        getRugs()
      }
    }

    removeQueryFromUrl = () => {
      const { router } = this.props

      router.replace('/search')
    }

    render() {
      const { filteredRugs, rugsError, rugsPending } = this.props

      return (
        <WrappedComponent
          hasError={rugsError}
          loaderPending={rugsPending && !rugsError}
          removeQueryFromUrl={this.removeQueryFromUrl}
          rugs={filteredRugs}
          rugsRaw={this.props.rugsRaw}
          {...this.props}
        />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    allRugs: selectors.filterRugs(state),
    dones: selectors.dones(state),
    errors: selectors.errors(state),
    extendedFilters: selectors.extendedFilters(state),
    filteredRugs: selectors.slicedFilteredRugs(state),
    filters: selectors.filters(state),
    layout: selectors.layout(state),
    limit: selectors.limit(state),
    pagination: selectors.calculatePagination(state),
    pendings: selectors.pendings(state),
    previewOpen: selectors.previewOpen(state),
    rugsDone: selectors.rugsDone(state),
    rugsError: selectors.rugsError(state),
    rugsPending: selectors.rugsPending(state),
    rugsRaw: selectors.rugs(state),
    searchForm: selectors.searchForm(state),
    sortBy: selectors.sortBy(state),
    sortOrder: selectors.sortOrder(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    exportToExcel: rugs => dispatch(rugsAsyncActions.rugsExportExcel(rugs)),
    getRugs: () => dispatch(rugsAsyncActions.rugsGet()),
    resetSaveSearch: () => dispatch(actions.resetSaveSearch()),
    saveSearch: (name, params, currentResults, rugs, user) => dispatch(asyncActions.saveSearch(name, params, currentResults, rugs, user)),
    setPage: page => dispatch(pageSet(page)),
    setSortBy: column => dispatch(sortBySet(column)),
    toggleLayout: () => dispatch(layoutToggle()),
    toggleLimit: () => dispatch(limitToggle()),
    togglePreview: () => dispatch(previewModalToggle()),
    toggleSearchForm: () => dispatch(actions.searchFormToggle()),
    toggleSortOrder: order => dispatch(sortOrderToggle()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SearchModuleEnhancer)
}

export default SearchModuleEnhancer
